<template>
  <div id="app">
    <div id="app_contents">
      <router-view />
    </div>
    <my-tabbar></my-tabbar>
  </div>
</template>

<script>
import firebase from "firebase";
import MyTabbar from "@/components/MyTabbar";
export default {
  components: {
    MyTabbar
  },
  mounted: function() {},
  methods: {}
};
</script>

<style>
html {
  font-family: "Noto Sans JP", "Nunito", "Varela Round", "Kosugi Maru",
    -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue",
    Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji",
    "Segoe UI Symbol", "Noto Color Emoji";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: rgba(0, 0, 0, 0.04);
}
body {
  /* これがないと左右に周りに微妙に空白ができるので */
  margin: 0;
}
#app_contents {
  margin-bottom: 12vh;
}
.send_btn {
  margin: 5vh auto;
  width: 80vw;
  padding: 0.7rem;
  font-weight: bold;
  text-align: center;
  color: #fff;
  font-size: 1.1rem;
  border-radius: 30px;
  background: #3ab795;
}
/* 16px以下だとズームしてしまうので */
input[type="text"] {
  font-size: 16px;
}
</style>
